module.exports = __webpack_public_path__ + "static/media/circle_info.b2bd0056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/circle_info.svg
// module id = 1218
// module chunks = 0